import { Locale } from '@enmon/commons';
import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSessionStore } from 'store/session';
import { isNil } from 'rambda';
import { BuildingFloor as messages } from './messages';

interface CommonBuildingFloorProps {
  level?: number | null;
}

const UpperFloorMessage: VFC<CommonBuildingFloorProps> = ({ level }) => (
  <FormattedMessage {...messages.floor} values={{ level }} />
);

const UndergroundFloorMessage: VFC<CommonBuildingFloorProps> = ({ level }) => {
  if (isNil(level)) return null;

  return <FormattedMessage {...messages.undergroundFloor} values={{ level: Math.abs(level) }} />;
};

/**
 * For CS and SK Locale we want to handle building floor messages from the civil engineering standing point,
 * where the ground floor is the first floor.
 */
export const BuildingFloor: VFC<CommonBuildingFloorProps> = ({ level }) => {
  const { locale } = useSessionStore();

  if (isNil(level)) {
    return null;
  }

  switch (locale) {
    case Locale.EN:
      if (level < 0) return <UndergroundFloorMessage level={level} />;
      if (level > 0) return <UpperFloorMessage level={level} />;

      return <FormattedMessage {...messages.groundFloor} />;
    default:
      if (level < 0) return <UndergroundFloorMessage level={level} />;

      // NOTE: Ground floor is 0, so we need to add 1 to the level
      return <UpperFloorMessage level={level + 1} />;
  }
};
